module.exports = __webpack_public_path__ + "media/images/upload-icon-efdff37da0fbfe6f902bdc70413440d9.svg";